export function getItem<T>(key: string): T | null {
  try {
    const data = localStorage.getItem(key);

    if (data === null) {
      return null;
    }

    return JSON.parse(data) as T;
  } catch {
    return null;
  }
}

function setItem(key: string, value: unknown) : void {
  try {
    const data = JSON.stringify(value);

    localStorage.setItem(key, data);
  } catch {
    // Do nothing
  }
}

export const jsonStorage = {
  getItem,
  setItem
};
